<h3>{{data.head}}</h3>
<hr>

<div *ngIf="extension == 'mp4'" style="text-align: center;">
    <video width="600" height="240" controls>
        <source [src]="data.fileUrls?.url" type="video/mp4">
        <source [src]="data.fileUrls?.url" type="video/ogg">
        Your browser does not support the video tag.
    </video>
</div>

<ngx-doc-viewer *ngIf="extension == 'pdf'" [url]="data.fileUrls?.url" viewer="google" googleCheckContentLoaded="true"
    googleCheckInterval=1000 googleMaxChecks=5 style="width:100%;height:70vh;">
</ngx-doc-viewer>


<div *ngIf="extension == 'jpeg' || extension == 'jpg' || extension == 'png'" style="text-align: center;">
    <div style="text-align: center; padding: 20px;">
        <div class="image-preview-container">
            <img [src]="data.fileUrls?.url" alt="Preview" class="preview-image"
                style="width: 100%;height: 100%;cursor: pointer;object-fit: contain;" />
            <div class="image-actions" style="position: relative;margin-top: 20px;">
                <button (click)="downloadImage()" class="btn btn-primary mt-3 ng-star-inserted" style="cursor: pointer;">
                    <i class="fa fa-download"></i> Download
                </button>
            </div>
        </div>
    </div>
</div>

<button mat-icon-button (click)="onNoClick()">
    <mat-icon>close</mat-icon>
</button>